var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4997 8.33326L12.1664 4.99993M2.58301 17.9166L5.40331 17.6032C5.74789 17.5649 5.92018 17.5458 6.08121 17.4937C6.22408 17.4474 6.36005 17.3821 6.48541 17.2994C6.62672 17.2062 6.7493 17.0836 6.99445 16.8385L17.9997 5.83326C18.9202 4.91279 18.9202 3.4204 17.9997 2.49993C17.0792 1.57945 15.5868 1.57945 14.6664 2.49992L3.66112 13.5052C3.41596 13.7503 3.29339 13.8729 3.20021 14.0142C3.11753 14.1396 3.05219 14.2755 3.00594 14.4184C2.9538 14.5794 2.93466 14.7517 2.89637 15.0963L2.58301 17.9166Z",
    stroke: "#FF0000",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6f31af5a0095d763632de5997a9904e1.svg";
export { ForwardRef as ReactComponent };